<template>
  <div class="flex flex-col gap-4">
    <div class="flex aspect-[16/9] w-full rounded-xl skeleton-loading-bg" />
    <div class="flex justify-end">
      <div class="w-20 h-5 skeleton-loading-bg rounded"></div>
    </div>
    <div class="flex flex-col gap-2">
      <div class="w-20 h-5 skeleton-loading-bg rounded"></div>
      <div class="w-24 h-5 skeleton-loading-bg rounded"></div>
      <div class="w-28 h-5 skeleton-loading-bg rounded"></div>
      <div class="w-64 max-w-full h-5 skeleton-loading-bg rounded"></div>
    </div>
    <div class="rounded p-4 grid grid-cols-5 gap-3">
      <div
        v-for="i in 5"
        :key="i"
        class="flex flex-col gap-2 justify-between items-center"
      >
        <div class="w-10 h-5 skeleton-loading-bg rounded"></div>
        <div class="w-full h-5 skeleton-loading-bg rounded"></div>
      </div>
    </div>
  </div>
</template>
